import { useCallback, useContext } from "react"
import { create } from "zustand"
import type { GL_WEB_SDK } from "@hg/gl-web-sdk/dist/index"
import type { HG_SDK } from "@hg/hg-web-sdk/dist/core/index"

import { GlobalContext } from "@/topic/rogue_5/context"

type HG_WEB_SDK_TYPE = typeof HG_SDK
type GL_WEB_SDK_TYPE = typeof GL_WEB_SDK

type GLSdkReady = (
    callback?: ((sdk: GL_WEB_SDK_TYPE) => void) | undefined
) => Promise<GL_WEB_SDK_TYPE>

type HGSdkReady = (
    callback?: ((sdk: HG_WEB_SDK_TYPE) => void) | undefined
) => Promise<HG_WEB_SDK_TYPE>

export interface I18nStore {
    text: Record<string, string>
    data: Record<string, any>
    sdkReady?: GLSdkReady | HGSdkReady
    collect?: HG_WEB_SDK_TYPE["ETL"]["event"]
}

export const useI18nStore = create<I18nStore>(() => ({
    text: {},
    data: {},
}))

export const useTranslation = () => {
    const text = useI18nStore((state) => state.text)
    const t = useCallback(
        (key: string) => {
            return text[key]
        },
        [text]
    )
    return { t, dict: text }
}

export const useETL = () => {
    const collect = useI18nStore((state) => state.collect)
    const {
        state: { user },
    } = useContext(GlobalContext)
    return useCallback(
        (eventName: string, payload: Record<string, any>) => {
            const p = user ? { ...payload, game_uid: user?.uid } : payload
            collect?.(eventName, p)
        },
        [user, collect]
    )
}
